import BaseApi from '@/api/rest/base/BaseApi';

export default class UserStatisticApi extends BaseApi {
  static entityName = 'user_statistics';
}
